import { EmbedUrlRequest, EmbedUrlResponse } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

// Direct-Pattern port of the portal's legacy tuple hook usePostEmbedUrl.
export default function useGenerateEmbedUrl() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);

  async function generateEmbedUrl(params: EmbedUrlRequest): Promise<EmbedUrlResponse> {
    try {
      setFetching(true);

      const res = await api.postEmbedUrl(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, generateEmbedUrl };
}
